export enum InviteStatus {
  PENDING = 'Pending',
  EXPIRED = 'Expired',
  RECALLED = 'Recalled',
}
